export const CATEGORIES = {
  ROOMS: 'rooms',
  FOOD_BEVERAGE: 'food-beverage',
  RETAIL: 'retail',
  CATERING_EVENTS: 'catering-events',
  PARKING: 'parking',
  SPA_WELLNESS: 'spa-wellness',
  GOLF: 'golf',
  PACKAGE: 'package',
  OTHER: 'other',
  FEES: 'fees',
  NON_REVENUE: 'non-revenue',
  UNMAPPED: 'unmapped',
} as const;

export type Category = (typeof CATEGORIES)[keyof typeof CATEGORIES];

export const SUB_CATEGORIES = {
  BANQUET_EVENT_SPACE: 'catering-events.banquet-event-space',
  EQUIPMENT_AV: 'catering-events.equipment-av',
  CATERING_EVENTS_FEES_MISC: 'catering-events.fees-misc',
  CATERING_EVENTS_FOOD_BEVERAGE: 'catering-events.food-beverage',
  CATERING_EVENTS_LABOR: 'catering-events.labor',
  CATERING_EVENTS_MEETING_ROOM_SPACE: 'catering-events.meeting-room-space',
  CANCELLATION: 'fees.cancellation',
  PENALTIES: 'fees.penalties',
  RESORT_FEE: 'fees.resort-fee',
  SPECIAL_EVENTS: 'fees.special-events',
  BAR: 'food-beverage.bar',
  BREAKFAST: 'food-beverage.breakfast',
  CAFE_COFFEE_BAR: 'food-beverage.cafe-coffee-bar',
  IN_ROOM_DINING: 'food-beverage.in-room-dining',
  MINIBAR: 'food-beverage.minibar',
  OTHER_FOOD_BEVERAGE: 'food-beverage.other',
  RESTAURANT: 'food-beverage.restaurant',
  GOLF: 'golf.golf',
  NON_REVENUE_OTHER: 'non-revenue.other',
  NON_REVENUE_TAXES: 'non-revenue.taxes',
  NON_REVENUE_TIPS_GRATUITIES: 'non-revenue.tips-gratuities',
  OTHER_EQUIPMENT: 'other.equipment',
  OTHER_FAX_PHONE: 'other.fax-phone',
  OTHER_INTERNET: 'other.internet',
  OTHER_LAUNDRY_DRY_CLEANING: 'other.laundry-dry-cleaning',
  OTHER_OTHER: 'other.other',
  OTHER_TRANSPORTATION: 'other.transportation',
  PACKAGE: 'package.package',
  PARKING_DAY: 'parking.day',
  PARKING_OVERNIGHT: 'parking.overnight',
  RETAIL_SHOP: 'retail.shop',
  RETAIL_VENDING: 'retail.vending',
  ROOMS_ACCOMMODATIONS: 'rooms.accommodations',
  ROOMS_FEES_MISC: 'rooms.fees-misc',
  ROOMS_REDEMPTIONS: 'rooms.redemptions',
  SPA_WELLNESS_BODY_MASSAGE_SAUNA_ETC: 'spa-wellness.body-massage-sauna-etc',
  SPA_WELLNESS_FACE: 'spa-wellness.face',
  SPA_WELLNESS_FITNESS_TRAINING: 'spa-wellness.fitness-training',
  SPA_WELLNESS_HAIR_MAKE_UP: 'spa-wellness.hair-make-up',
  SPA_WELLNESS_HANDS_FEET: 'spa-wellness.hand-feet',
  SPA_WELLNESS_OTHER: 'spa-wellness.other',
  UNMAPPED: 'unmapped',
} as const;

export type SubCategory = (typeof SUB_CATEGORIES)[keyof typeof SUB_CATEGORIES];

export const FILTER_IDS = {
  TRANSACTION_CODE: 'transactionCode',
  PMS_DESCRIPTION: 'pmsDescription',
  HOTEL_NAME: 'hotelName',
} as const;

export type FilterId = (typeof FILTER_IDS)[keyof typeof FILTER_IDS];
